import { useQuery } from "react-query";

import { useSingleConnector } from "../useConnectors";
import { getConnectorEnergyConsumptionData } from "../../services/stationsAPI";
import { useGetAnalysisFilter } from "../../../../common/analysis/filter/hook/core/useFilterAnalysisCore";

export const useConnectorEnergyConsumptionData = () => {

    
    const {filter} = useGetAnalysisFilter();
    

    const {connectorIdFound} = useSingleConnector({});


    const energyConsumptionConnector = useQuery({
        queryKey: ['connectorEnergyConsumption', connectorIdFound, filter],
        queryFn: () => getConnectorEnergyConsumptionData(connectorIdFound || "none", filter),
        enabled: !!connectorIdFound,
        refetchOnWindowFocus: false,
    })  



    return {
        filter,
        energyConsumptionConnector,
    }
}